import { type MouseEvent, useCallback } from 'react'
import { Link, type LinkProps } from 'react-router'

// Link component that uses React Router's native View Transitions API support
export function ViewTransitionLink({
	to,
	children,
	onClick,
	...props
}: LinkProps) {
	const handleClick = useCallback(
		(e: MouseEvent<HTMLAnchorElement>) => {
			if (onClick) {
				onClick(e)
			}

			// Clear any case-transition class to ensure we get the default animation
			document.body.classList.remove('case-transition')
		},
		[onClick],
	)

	return (
		<Link to={to} onClick={handleClick} viewTransition {...props}>
			{children}
		</Link>
	)
}
